import { FC, PropsWithChildren } from 'react'

export const SubTitle: FC<PropsWithChildren<{ extraCls?: string }>> = props => {
  return <h3 className={`font-bold uppercase ${props.extraCls || ''}`}>{props.children}</h3>
}

export const EndNode: FC<{ content: string | Record<string, any>; className?: string }> = ({ content, className }) => {
  if (typeof content === 'string') {
    return <>{content?.replace(/&nbsp;/g, ' ')}</>
  } else {
    return (
      <>
        {content.beforeLink}
        <a href={content.link} className={`clickable-text ${className || ''}`}>
          {content.text}
        </a>
        {content.afterLink}
      </>
    )
  }
}

export const Section: FC<{ paragraphs: Array<any>; paragraphCls?: string; extraCls?: string }> = ({ paragraphs, paragraphCls, extraCls }) => {
  return (
    <div className={`${extraCls || ''}`}>
      {paragraphs.map((paragraph, i) => (
        <p key={`paragraph-${i}`} className={`text-sm ${paragraphCls || ''} ${paragraph?.startsWith?.('&nbsp;') ? 'ml-6' : ''}`}>
          <EndNode content={paragraph} />
        </p>
      ))}
    </div>
  )
}

export const SectionList: FC<{ list: Array<any>; listCls: string; listCls2?: string }> = ({ listCls, listCls2, list }) => {
  const content = []
  const listItemCls = 'mt-2 text-sm'

  for (let i = 0; i < list.length; i++) {
    const tierOne = list[i]
    if (typeof tierOne === 'string' || tierOne.link) {
      content.push(
        <li key={'tierOne-' + i} className={listItemCls}>
          <EndNode content={tierOne} />
        </li>
      )
    } else {
      content.push(
        <ol key={'tierOne-' + i} className={`list-outside ${listCls2 || ''}`}>
          {tierOne.map((tierTwo, j) => {
            if (typeof tierTwo === 'string' || tierTwo.link) {
              return (
                <li key={'tierTwo-' + j} className={listItemCls}>
                  <EndNode content={tierTwo} />
                </li>
              )
            } else {
              return (
                <ul key={'tierTwo-' + j} className='contents'>
                  {tierTwo.map((tierThree: any, k: number) => (
                    <li key={`tierThree-${k}`} className={`${listItemCls} list-none pl-4`}>
                      <EndNode content={tierThree} />
                    </li>
                  ))}
                </ul>
              )
            }
          })}
        </ol>
      )
    }
  }
  return <ol className={`${listCls} list-outside pl-4`}>{content}</ol>
}

export const Table: FC<{ headers: Array<string>; rows: Array<Array<string | Array<string>>>; extraCls?: string }> = ({ headers, rows, extraCls }) => {
  const cellCls = 'p-2 text-sm md:p-4'
  return (
    <table className={`block table-auto overflow-x-auto rounded-lg ${extraCls || ''}`}>
      <thead>
        <tr className='border-b-2 bg-white/100'>
          {headers.map((item, index) => (
            <th className={`${cellCls} text-left font-bold`} key={index}>
              <EndNode content={item} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr className='odd:bg-white/100 even:bg-stone-50' key={i}>
            {row.map((cell, j) => (
              <td className={`${cellCls}${i == rows.length - 1 ? ' first:rounded-bl-lg last:rounded-br-lg' : ''}`} key={j}>
                {typeof cell === 'string' ? (
                  <EndNode content={cell} />
                ) : (
                  <Section key={`table-cell-${i}-${j}`} paragraphs={cell} extraCls='' paragraphCls='mt-0.5' />
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
